// extracted by mini-css-extract-plugin
export default {"root":"O8o2bNGKCi","title":"z0HDc9UwIj","selectableText":"n7XiULf60e"};